module.exports = "<div class=\"row\">\n  <div class=\"col-sm-8\">\n    <img src=\"assets/logo.png\" class=\"img-fluid\">\n  </div>\n</div>\n"